var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { getDetailAddress } from "./detail";
export default function AddressFieldList(_a) {
    var fieldName = _a.fieldName, record = _a.record, fieldMetadata = _a.fieldMetadata, fieldDef = _a.fieldDef;
    var group = fieldMetadata.group;
    var value = useMemo(function () {
        if (!record) {
            return;
        }
        return getDetailAddress(group, record, fieldDef);
    }, [fieldName, record]);
    return (_jsx("div", __assign({ className: "" }, { children: _jsx("span", { children: value.street +
                " " +
                value.city +
                " " +
                value.postalcode +
                " " +
                value.state +
                " " +
                value.country }) })));
}
